import { createAction } from '@reduxjs/toolkit';
import { TimesheetMeta } from 'contexts/timesheet-meta';

export const fetchTimesheetMetaSagaAction = createAction('timesheet/getMeta');

export interface SaveTimesheetMetaPayload {
  timesheetMeta: TimesheetMeta;
  handleSuccess?(): void;
  handleError?(): void;
  handleAlways?(): void;
}
export const saveTimesheetMetaSagaAction =
  createAction<SaveTimesheetMetaPayload>('timesheet/saveMeta');
